import axios from 'axios'

export default async (idInvoice,payable) => {
    try {
      let path = `/pch_purchase_invoice/${idInvoice}/payable`
      let route  =  process.env.VUE_APP_API_ROUTE.concat(path)
      let response = await axios.put(route,{
          payable : payable
        })
      return response
    } catch (error) {
        return error.data.response
    }
}
